import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

class CartRecommendations {

    constructor(node) {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        this.root = node;

        if ( this.root.classList.contains('swiper-initialized') ) {
            return;
        }

        this.root.classList.add('swiper', 'swiper--mobile-only');
        this.swiper = this.root;

        this._init();
    }

    _init() {

        // Add wrapper class if <ul> exists
        const ul = this.root.querySelector('ul.products');

        if (ul) {
            ul.classList.add('swiper-wrapper');

            // Add slide class to each product
            ul.querySelectorAll('li.product').forEach(li => {
                li.classList.add('swiper-slide');
            });
        } else {
            console.warn('No <ul.products> found inside', this.root);
            return; // don’t init Swiper without slides
        }

        // Add pagination node if missing
        if (!this.root.querySelector('.swiper-pagination')) {
            const pagination = document.createElement('div');
            pagination.classList.add('swiper-pagination');
            this.root.appendChild(pagination);
        }

        Swiper.use([ Pagination ]);

        new Swiper(this.swiper, {
            slidesPerView: 1,
            spaceBetween: 20,
            breakpoints: {
                0:   { enabled: true,  slidesPerView: 1 }, // ≤575px -> 1 slide
                576: { enabled: true,  slidesPerView: 2 }, // 576–767px -> 2 slides
                992: { enabled: true,  slidesPerView: 3 }, // 768–991px -> 3 slides
                1200: { enabled: false }                    // ≥992px -> no slider
            },
            pagination: {
                el: this.root.querySelector('.swiper-pagination'),
                clickable: true
            }
        });

        console.log('Swiper initialised for', this.root);
    }
}

[...document.querySelectorAll('.woocommerce-order-received .wc-prl-recommendations')].forEach(node => {
    new CartRecommendations(node);
});